import { AccountApi } from './api'
import __C from '../primitives/_constant_'
import __M from 'moment'
export default class AccountService {
    
  constructor() {
    this.accountApi = new AccountApi()
  }

  signin(creds, callback) {
    this.accountApi.signin(creds, account => {
      // login success if there's a jwt token in the response
      if(account.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem(__C.LOCAL_STORAGE_NAME.ACCOUNT, JSON.stringify(account))
        localStorage.setItem(__C.LOCAL_STORAGE_NAME.TIMEOUT, __M().format('YYYY-MM-DD HH:mm:ss'))
      } else {
        account.error = true
      }
      callback(account)
    })
  }

  signout(callback) {
    localStorage.removeItem(__C.LOCAL_STORAGE_NAME.ACCOUNT)
    callback()
  }
}
